import { Component, HostBinding, Input } from '@angular/core';

@Component({
    selector: 'genesis-frontend-recommendation-card-actions',
    templateUrl: './recommendation-card-actions.component.html',
    styleUrls: ['./recommendation-card-actions.component.scss']
})
export class RecommendationCardActionsComponent {
    @Input() @HostBinding('attr.id') id = '';

    @HostBinding('class') class = 'recommendation-card-actions flex justify-between align-center';
}
